<!-- =========================================================================================
	File Name: BuyNow.vue
	Description: Buy Now Button
	Component Name: BuyNow
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <date-picker 
        :type=type
        v-bind="{range : range}"
        :format=format
        :placeholder=placeholder
        :clearable=clearable
        :editable=editable
        :inline=inline
        :range-separator=rangeSeparator
        :show-week-number=showWeekNumber
        :append-to-body="false"
        v-model="dateRange"
        :disabled-date="blockDates"
        @input="selectedOption"
    >
        <div slot="input">
            <!-- <vs-button size="small" color="dark" type="line" icon-pack="feather" icon="icon-menu" icon-after>{{dateRange[0] | date}} {{rangeSeparator}} {{dateRange[1] | date}}</vs-button> -->
            <vs-chip>
                <vs-avatar icon-pack="feather" icon="icon-calendar" />
                <span v-if="range">{{dateRange[0] | date}} {{rangeSeparator}} {{dateRange[1] | date}}</span>
                <span v-if="!range">{{dateRange | date('ddd, MMM Do Y')}}</span>
            </vs-chip>
        </div>
        <div slot="icon-calendar">
        </div>
        <div slot="icon-clear">
        </div>
        <template v-slot:header="{ emit }" v-if="showShortcut">
          <div style="text-align: left">
            <button class="mx-btn mx-btn-text" @click="selectToday(emit)">
              Today
            </button>
          </div>
        </template>
    </date-picker>
</template>

<script>
import appConfig from '@/../appConfig.js';
import { appCommons } from "@/app/shared/services";

import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';

export default {
    name: 'date-pick',
    props: {
        type: {
            type: String,
            default: 'date',
        },
        range: {
            type: Boolean,
            default: false,
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD',
        },
        placeholder: {
            type: String,
            default: 'Select time span',
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        inline: {
            type: Boolean,
            default: false,
        },
        rangeSeparator: {
            type: String,
            default: '~',
        },
        showWeekNumber: {
            type: Boolean,
            default: true,
        },
        showShortcut: {
            type: Boolean,
            default: false,
        },
        dateScope: {
            // type: Object,
            required: true
        }
    },
    data() {
        return {
            minDate: new Date("01/01/2017"),
            maxDate: new Date(),
            dateRange: [],
        }
    },
    watch: {
    // UPDATE ON dateScope CHANGE
        dateScope(val) {
            this.init();
        }
    },
    methods: {
        init() {
            let dateScope = this.dateScope ? this.dateScope : appCommons.allowedDateScope(
                "",
                90,
                "minus",
                null,
                null
            );

            this.minDate = new Date(dateScope.minDate);
            this.maxDate = new Date(dateScope.maxDate);
            if(this.range) {
                this.dateRange = [];
                this.dateRange.push(new Date(dateScope.startDate));
                this.dateRange.push(new Date(dateScope.endDate));
            } else {
                this.dateRange = new Date(dateScope.endDate);
            }
            

            this.selectedOption();
        },
        selectToday(emit) {
            const start = new Date();
            const end = new Date();
            end.setTime(end.getTime() + 3 * 24 * 3600 * 1000);
            const date = [start, end];
            emit(date);
            this.init();
        },        
        blockDates(date) {
            // let minDate = this.minDate ? this.minDate : new Date("01/01/2017");
            // let maxDate = this.maxDate ? this.maxDate : new Date();

            return date < this.minDate || date > this.maxDate;
        },
        selectedOption() {
            let startDate = new Date();
            let endDate = new Date();
            
            if(this.range) {
                startDate = this.dateRange && this.dateRange.length > 0 ? this.dateRange[0] : new Date();
                endDate = this.dateRange && this.dateRange.length > 1 ? this.dateRange[1] : new Date();
            } else {
                startDate = this.dateRange ? this.dateRange : new Date();
                endDate = this.dateRange ? this.dateRange : new Date();
            }
            
            this.$emit('dateRange', {startDate: startDate, endDate: endDate});
        },
    },
    mounted() {
        this.init();
    },  
    components: {
        DatePicker
    }
}
</script>

<style lang="scss">
$default-color: #555;
$primary-color: #5ec7ff;//#1284e7;

@import '~vue2-datepicker/scss/index.scss';

    .mx-datepicker-range {
        cursor: pointer;
        width: 100% !important;
    }

    .mx-datepicker {
        cursor: pointer;
    }

</style>
